import { PalletBox } from './pallet-box';

export interface InternalShipmentGroup {
  id: string;
  name: string;
  locationKey: string;
  carrierAccountKey: string;
  carrierAccountName: string;
  shipmentCount: number;
  isExpanded?: boolean;
  palletBoxes: PalletBox[];
  tag: null | string;
}

export enum ShipmentGroupOptions {
  ALWAYS_VISIBLE = 'ALWAYS_VISIBLE',
  ALWAYS_HIDDEN = 'ALWAYS_HIDDEN',
  DEFAULT = 'DEFAULT',
}

export interface ShipmentGroupConfiguration {
  id: string;
  name: string;
  carrierAccountKeys: string[];
  tag: null | string;
  locationKey: string;
  option: ShipmentGroupOptions;
  pinned: boolean;
  manualLoadDisabled?: boolean;
}

export interface ShipmentGroup {
  id: string;
  name: string;
  internalShipmentGroups: {
    id: string;
    name: string;
    key: string;
    shipmentCount: number;
  }[];
  shipmentCount: number;
  tag: string | null;
  palletBoxes: PalletBox[];
  pinned: boolean;
  option: ShipmentGroupOptions;
  manualLoadDisabled: boolean;
}
